import { FontSizing } from '@eversports/react-components/design-tokens/theme'
import Icon from '@eversports/react-components/primitives/Icon'
import PaypalIcon from '@eversports/react-components/primitives/Icon/custom-icons/PayPal'
import BancontactIcon from '@eversports/react-components/primitives/Icon/custom-icons/Bancontact'
import KlarnaSofortIcon from '@eversports/react-components/primitives/Icon/custom-icons/KlarnaSofort'
import MasterCardIcon from '@eversports/react-components/primitives/Icon/custom-icons/MasterCard'
import VisaIcon from '@eversports/react-components/primitives/Icon/custom-icons/Visa'
import AmericanExpressIcon from '@eversports/react-components/primitives/Icon/custom-icons/AmericanExpress'
import DiscoverIcon from '@eversports/react-components/primitives/Icon/custom-icons/Discover'
import DinnersClubIcon from '@eversports/react-components/primitives/Icon/custom-icons/DinnersClub'
import UnionPayIcon from '@eversports/react-components/primitives/Icon/custom-icons/UnionPay'
import JapanCreditBureauIcon from '@eversports/react-components/primitives/Icon/custom-icons/JapanCreditBureau'
import IdealIcon from '@eversports/react-components/primitives/Icon/custom-icons/Ideal'
import SepaIcon from '@eversports/react-components/primitives/Icon/custom-icons/Sepa'
import MultibancoIcon from '@eversports/react-components/primitives/Icon/custom-icons/Multibanco'
import OnSiteIcon from '@eversports/react-components/primitives/Icon/custom-icons/OnSite'
import EPSIcon from '@eversports/react-components/primitives/Icon/custom-icons/Eps'
import GiropayIcon from '@eversports/react-components/primitives/Icon/custom-icons/Giropay'
import TwintIcon from '@eversports/react-components/primitives/Icon/custom-icons/Twint'
import CartesBancairesIcon from '@eversports/react-components/primitives/Icon/custom-icons/CartesBancaires'

import { assertNever } from '@eversports/utility-types'
import React from 'react'

import {
  AdditionalPaymentMethodType,
  CustomPaymentMethodType,
  PaymentMethodType,
  PaymentMethodVerificationMethod,
} from '../../typings/Payment'

interface Props {
  paymentMethodType: AdditionalPaymentMethodType
  verifyWith?: PaymentMethodVerificationMethod | null
  size: FontSizing | Array<FontSizing>
}

const PaymentMethodIcon: React.FC<React.PropsWithChildren<Props>> = ({ paymentMethodType, verifyWith, size }) => {
  switch (paymentMethodType) {
    case PaymentMethodType.PAYMENT_METHOD_PAYPAL:
      return <Icon size={size} icon={PaypalIcon} />
    case PaymentMethodType.PAYMENT_METHOD_BANCONTACT:
      return <Icon size={size} icon={BancontactIcon} />
    case PaymentMethodType.PAYMENT_METHOD_SOFORT:
      return <Icon size={size} icon={KlarnaSofortIcon} />
    case PaymentMethodType.PAYMENT_METHOD_EPS:
      return <Icon size={size} icon={EPSIcon} />
    case PaymentMethodType.PAYMENT_METHOD_TWINT:
      return <Icon size={size} icon={TwintIcon} />
    case PaymentMethodType.PAYMENT_METHOD_GIROPAY:
      return <Icon size={size} icon={GiropayIcon} />
    case PaymentMethodType.PAYMENT_METHOD_CREDIT_CARD:
      return (
        <>
          <Icon size={size} icon={MasterCardIcon} />
          <Icon size={size} icon={VisaIcon} />
          <Icon size={size} icon={AmericanExpressIcon} />
          <Icon size={size} icon={DiscoverIcon} />
          <Icon size={size} icon={DinnersClubIcon} />
          <Icon size={size} icon={UnionPayIcon} />
          <Icon size={size} icon={JapanCreditBureauIcon} />
          <Icon size={size} icon={CartesBancairesIcon} />
        </>
      )
    case PaymentMethodType.PAYMENT_METHOD_IDEAL:
      return <Icon size={size} icon={IdealIcon} />
    case PaymentMethodType.PAYMENT_METHOD_SEPA_ONLINE:
      if (verifyWith) {
        const verifyWithIcon = getVerifyWithIcon(verifyWith)
        return (
          <>
            <Icon size={size} icon={SepaIcon} />
            <Icon size={size} icon={verifyWithIcon} />
          </>
        )
      }
      return <Icon size={size} icon={SepaIcon} />
    case PaymentMethodType.PAYMENT_METHOD_MULTIBANCO:
      return <Icon size={size} icon={MultibancoIcon} />
    case CustomPaymentMethodType.PAYMENT_METHOD_OFFLINE:
      return <Icon size={size} icon={OnSiteIcon} />
    default:
      return assertNever(paymentMethodType)
  }
}

const getVerifyWithIcon = (verifyWith: PaymentMethodVerificationMethod) => {
  switch (verifyWith) {
    case PaymentMethodVerificationMethod.PAYMENT_METHOD_IDEAL:
      return IdealIcon
    case PaymentMethodVerificationMethod.PAYMENT_METHOD_SOFORT:
      return KlarnaSofortIcon
    default:
      return assertNever(verifyWith)
  }
}

export default PaymentMethodIcon
